document.addEventListener("page:load", function () {
  if (typeof window.QueueIt !== "undefined") {
    window.QueueIt.Javascript
      .PageEventIntegration
      .initQueueClient(window.queueit_clientside_config);
  }
});
